<!-- This component is does noting except updating the shadow of the main menu when one of its summary item gets opened -->
<script>
    import $ from 'bianco.query';
    import { has } from 'bianco.attr';
    import { mapActions } from 'vuex';

    export default {
        methods: {
            ...mapActions('desktop-menu', ['setShadow']),
            updateShadow() {
                // check if all the '<details>' tags are closed
                const hasOpenDetails = this.details.some(el => has(el, 'open'));

                this.setShadow({ hasBigShadow: !hasOpenDetails });
            },
        },
        mounted() {
            const observerConfig = { attributes: true, childList: false, subtree: true };
            this.observer = new MutationObserver(this.updateShadow);
            this.details = $('details', this.$el);

            // watch the open attribute change
            this.observer.observe(this.$el, observerConfig);
        },
        beforeDestroy() {
            this.observer.disconnect();
        },
    };
</script>
